import PLAYTECHLIVEActions from './PLAYTECHLIVEActions'

export default class PLAYTECHSLOTActions extends PLAYTECHLIVEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameCode: 'PLAYTECH-SLOT-001',
      platform: 'PLAYTECH',
    }

    this.gameName = 'The Grim Reaper'

    this.constantGameInfo = {
      betDetails: {
        tableCoverage: 0,
        betType: 'MAIN_BET',
      },
    }

    // 56_87072152#47bf539a, 56_87072153#47bf539a
    this.roundIdPrefix = '56'
    this.roundIdSufix = '47bf539a'

    // platformTxId: 116316751
  }
}
